import moment from "moment";
import API from "../../Api/Api";
import QueryString from "qs";
import { API_END_POINT } from "../../Api/EndPoints";
import { isDefined, uploadFile } from "../../Utils";
import { toast } from "react-toastify";
import { deleteRecord } from "../../Utils/api";

const getSearchFilters = (userRole, search) => {
  if ([0, 1]?.includes(userRole)) {
    return {
      $or: [
        {
          commande: {
            reseller: {
              name: {
                $containsi: search,
              },
            },
          },
        },
        {
          commande: {
            number: {
              $containsi: search,
            },
          },
        },
        {
          commande: {
            packings: {
              model: {
                reference: {
                  $containsi: search,
                },
              },
            },
          },
        },
        {
          commande: {
            packings: {
              refClient: {
                $containsi: search,
              },
            },
          },
        },
        {
          transporter: {
            name: {
              $containsi: search,
            },
          },
        },
        {
          number: {
            $containsi: search,
          },
        },
      ],
    };
  } else if (userRole === 3) {
    return {
      $or: [
        moment(search, "DD/MM/YYYY", true).isValid()
          ? {
              $and: [
                {
                  createdAt: {
                    $lte: moment(search, "DD/MM/YYYY")
                      .utc(true)
                      .endOf("day")
                      .toDate(),
                  },
                },
                {
                  createdAt: {
                    $gte: moment(search, "DD/MM/YYYY")
                      .utc(true)
                      .startOf("day")
                      .toDate(),
                  },
                },
              ],
            }
          : {},
        {
          commande: {
            reseller: {
              name: {
                $containsi: search,
              },
            },
          },
        },
        {
          commande: {
            number: {
              $containsi: search,
            },
          },
        },
        {
          commande: {
            packings: {
              model: {
                reference: {
                  $containsi: search,
                },
              },
            },
          },
        },
        {
          commande: {
            packings: {
              refClient: {
                $containsi: search,
              },
            },
          },
        },
        {
          number: {
            $containsi: search,
          },
        },
      ],
    };
  } else if (userRole === 4) {
    return {
      $or: [
        {
          commande: {
            reseller: {
              name: {
                $containsi: search,
              },
            },
          },
        },
        {
          commande: {
            number: {
              $containsi: search,
            },
          },
        },
        {
          number: {
            $containsi: search,
          },
        },
        {
          commande: {
            packings: {
              serialNumber: {
                $containsi: search,
              },
            },
          },
        },
      ],
    };
  }
  return {};
};

export const getDeliveries =
  (page = 1, search, userFilters, signal) =>
  async (dispatch, getState) => {
    const user = getState().userReducer.user;
    dispatch({ type: "DELIVERIES_LOADING", payload: true });
    try {
      let filters = {
        $and: [
          {
            storekeeper: {
              id: {
                $eq: userFilters?.storekeeper?.code,
              },
            },
          },
          {
            transporter: {
              id: {
                $eq: userFilters?.transporter?.code,
              },
            },
          },
          {
            date: {
              $eq: userFilters?.date
                ? moment(userFilters?.date).utc(true).toDate()
                : null,
            },
          },
          {
            commande: {
              reseller: {
                id: {
                  $eq: userFilters?.reseller?.code,
                },
              },
            },
          },
          {
            recupDate: {
              $eq: userFilters?.recupDate
                ? moment(userFilters?.recupDate).utc(true).toDate()
                : null,
            },
          },
          getSearchFilters(user?.attributes?.userRole, search),
        ],
      };
      if (user?.attributes?.userRole === 0) {
        filters = {
          ...filters,
          commande: {
            reseller: {
              profils: {
                user: {
                  id: {
                    $eq: user?.id,
                  },
                },
              },
            },
          },
        };
      } else if (user?.attributes?.userRole === 3) {
        filters = {
          ...filters,
          commande: {
            packings: {
              approvisionnement: {
                realEntrepot: {
                  storekeepers: {
                    user: {
                      id: {
                        $eq: user?.id,
                      },
                    },
                  },
                },
              },
            },
          },
        };
      } else if (user?.attributes?.userRole === 2) {
        filters = {
          ...filters,
          commande: {
            reseller: {
              business_affiliate: {
                user: {
                  id: {
                    $eq: user?.id,
                  },
                },
              },
            },
          },
        };
      } else if (user?.attributes?.userRole === 4) {
        filters = {
          ...filters,
          transporter: {
            id: {
              $eq: user?.attributes?.transporter?.data?.id,
            },
          },
        };
      }

      const { data } = await API.get("api/deliveries", {
        signal,
        params: {
          filters,
          sort: ["date:asc"],
          pagination: {
            page: 1,
            pageSize: 10,
          },
          populate: {
            commande: {
              populate: {
                packings: {
                  populate: {
                    model: {
                      populate: {
                        category: true,
                      },
                    },
                    approvisionnement: {
                      populate: {
                        realEntrepot: true,
                      },
                    },
                  },
                },
                reseller: true,
                addresseDeLivraison: {
                  populate: {
                    country: true,
                    city: true,
                  },
                },
              },
            },
            transporter: true,
            storekeeper: true,
          },
        },
      });
      if (page === 1) {
        dispatch({
          type: "DELIVERIES_DELIVERIES",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      } else {
        dispatch({
          type: "DELIVERIES_LOAD_MORE_SUCCESS",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return;
      dispatch({ type: "DELIVERIES_ERROR", payload: error });
    }
  };

export const getCurrentDelivery =
  ({ orderId, realDeliveryDate, isEstimatedDate, estimatedDeliveryDate }) =>
  async (dispatch) => {
    try {
      const populate = {
        commande: {
          fields: ["number"],
        },
      };
      const filters = {
        $or: [
          {
            commande: {
              id: {
                $eq: orderId,
              },
            },
          },
          isEstimatedDate
            ? estimatedDeliveryDate
              ? {
                  commande: {
                    estimatedDeliveryDate: {
                      $eq: moment(estimatedDeliveryDate)
                        .utc(true)
                        .startOf("day")
                        .format("YYYY-MM-DD"),
                    },
                  },
                }
              : {}
            : realDeliveryDate
              ? {
                  commande: {
                    realDeliveryDate: {
                      $eq: moment(realDeliveryDate)
                        .utc(true)
                        .startOf("day")
                        .format("YYYY-MM-DD"),
                    },
                  },
                }
              : {},
        ],
      };
      const { data } = await API.get("api/deliveries", {
        params: {
          filters,
          populate,
        },
      });

      if (data?.data?.length > 0) {
        dispatch({ type: "SET_DELIVERY", payload: data?.data[0] });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: "SET_ERROR", payload: error });
    }
  };

const handleActions = async (deliveryId, status) => {
  const statusList = ["READY", "RECUP", "DELIVERY", "DELIVERED"];
  if (!statusList?.includes(status)) return;
  const { data } = await API.get(`api/delivery-actions`, {
    params: {
      filters: {
        status: {
          $eq: status,
        },
        delivery: {
          id: {
            $eq: deliveryId,
          },
        },
      },
    },
  });
  const nextActions = statusList.slice(statusList.indexOf(status) + 1);
  if (nextActions?.length > 0) {
    const { data: nextActionsData } = await API.get(`api/delivery-actions`, {
      params: {
        filters: {
          status: {
            $in: nextActions,
          },
          delivery: {
            id: {
              $eq: deliveryId,
            },
          },
        },
      },
    });
    for (const action of nextActionsData?.data) {
      await deleteRecord(action?.id, "delivery-actions");
    }
  }

  if (data?.data?.[0]) {
    await API.put(`api/delivery-actions/${data?.data?.[0]?.id}`, {
      data: {
        date: moment().utc(true).toDate(),
      },
    });
  } else {
    await API.post(`api/delivery-actions`, {
      data: {
        delivery: deliveryId,
        status: status,
        date: moment().utc(true).toDate(),
      },
    });
  }
};

export const updateDelivery =
  (deliveryId, { ...rest }, callback = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "UPDATE_DELIVERY_LOADING" });
    try {
      await API.put(`api/deliveries/${deliveryId}`, {
        data: {
          ...rest,
        },
      });
      if (rest.status || rest.deliveryStatus) {
        await handleActions(deliveryId, rest.status || rest.deliveryStatus);
      }
      const { data } = await API.get(`api/deliveries/${deliveryId}`, {
        params: {
          populate: {
            commande: {
              populate: {
                packings: {
                  populate: {
                    approvisionnement: {
                      populate: {
                        realEntrepot: {
                          populate: {
                            address: {
                              populate: {
                                country: true,
                                city: true,
                              },
                            },
                          },
                        },
                      },
                    },
                    model: {
                      populate: {
                        product_size: true,
                        caracteristique: true,
                        category: true,
                      },
                    },
                  },
                },
                reseller: true,
                addresseDeLivraison: {
                  populate: {
                    country: true,
                    city: true,
                  },
                },
              },
            },
            transporter: true,
            depot: true,
            storekeeper: {
              populate: {
                user: true,
              },
            },
          },
        },
      });
      callback();
      dispatch({ type: "UPDATE_DELIVERY_SUCCESS", payload: data?.data });
    } catch (error) {
      console.log(error);
      dispatch({ type: "SET_ERROR", payload: error });
    }
  };

export const createDelivery =
  ({ commandeId, ...rest }) =>
  async (dispatch) => {
    try {
      const { data } = await API.post("api/deliveries", {
        data: {
          commande: commandeId,
          ...rest,
        },
      });
      return data?.data;
    } catch (error) {
      console.log(error);
      dispatch({ type: "SET_ERROR", payload: error });
    }
  };

export const deleteDelivery = (deliveryId) => async (dispatch) => {
  try {
    await API.delete(`api/deliveries/${deliveryId}`);
  } catch (error) {
    console.log(error);
    dispatch({ type: "SET_ERROR", payload: error });
  }
};

export const resetDelivery = () => async (dispatch) => {
  dispatch({ type: "SET_DELIVERY", payload: null });
};

export const getOrderDeliveries =
  ({ orderId, realDeliveryDate, isEstimatedDate, estimatedDeliveryDate }) =>
  async (dispatch) => {
    dispatch({ type: "ORDER_DELIVERIES_LOADING" });
    try {
      const populate = {
        commande: {
          fields: ["number"],
        },
      };
      const filters = {
        $or: [
          {
            commande: {
              id: {
                $eq: orderId,
              },
            },
          },
          estimatedDeliveryDate
            ? {
                commande: {
                  estimatedDeliveryDate: {
                    $eq: moment(estimatedDeliveryDate)
                      .utc(true)
                      .startOf("day")
                      .format("YYYY-MM-DD"),
                  },
                },
              }
            : {},
          realDeliveryDate
            ? {
                commande: {
                  realDeliveryDate: {
                    $eq: moment(realDeliveryDate)
                      .utc(true)
                      .startOf("day")
                      .format("YYYY-MM-DD"),
                  },
                },
              }
            : {},
        ],
      };
      const { data } = await API.get("api/deliveries", {
        params: {
          filters,
          populate,
        },
      });

      dispatch({ type: "ORDER_DELIVERIES_SUCCESS", payload: data?.data });
    } catch (error) {
      console.log(error);
      dispatch({ type: "ORDER_DELIVERIES_ERROR", payload: error });
    }
  };

export const getDelivery = (deliveryId, toastMessage) => async (dispatch) => {
  dispatch({ type: "GET_DELIVERY_LOADING" });
  try {
    const populate = {
      dateValidatedBy: { fields: ["firstName", "lastName"] },
      commande: {
        populate: {
          // Scénario B customer order: project + contact (date from the app).
          project: { fields: ["id", "number"] },
          client: { fields: ["firstName", "lastName"] },
          business_affiliate: {
            populate: {
              user: true,
            },
          },
          delivery_type: {
            populate: true,
          },
          reseller: true,
          packings: {
            populate: {
              approvisionnement: {
                populate: {
                  realEntrepot: {
                    populate: {
                      address: {
                        populate: {
                          country: true,
                          city: true,
                        },
                      },
                    },
                  },
                },
              },
              model: {
                populate: {
                  product_size: true,
                  caracteristique: true,
                  category: true,
                },
              },
            },
          },
          addresseDeLivraison: {
            populate: {
              country: true,
              city: true,
            },
          },
        },
      },
      crm: true,
      deliveryActions: {
        populate: true,
        sort: ["date:desc"],
      },
      deliveryAttachments: {
        populate: {
          file: true,
        },
      },
      preparationAttachments: {
        populate: {
          file: true,
        },
      },
      transporter: {
        populate: {
          user: true,
        },
      },
      depot: {
        populate: {
          address: {
            populate: {
              country: true,
              city: true,
            },
          },
        },
      },
      storekeeper: {
        populate: {
          user: true,
        },
      },
    };
    const { data } = await API.get(`api/deliveries/${deliveryId}`, {
      params: {
        populate,
      },
    });
    dispatch({ type: "GET_DELIVERY_SUCCESS", payload: data?.data });
    if (toastMessage) {
      toast.success(toastMessage);
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: "SET_ERROR", payload: error });
  }
};

export const getDeliveryComments = (delivery) => async (dispatch) => {
  try {
    dispatch({ type: "FETCH_COMMENTS_DELIVERY_LOADING" });
    const query = QueryString.stringify({
      populate: [
        "attachments.file",
        "user.photo",
        "user.marque",
        "emojis.user.photo",
        "emojis.user.profil.reseller",
        "emojis.user.business_affiliate",
        "emojis.user.transporter",
        "emojis.user.storekeeper",
      ],
      sort: ["createdAt:desc"],
      filters: {
        delivery: { id: { $eq: delivery } },
      },
    });
    const {
      data: { data: commentData },
    } = await API.get(`${API_END_POINT}api/comments?${query}`);
    dispatch({ type: "FETCH_COMMENTS_DELIVERY_SUCCESS", payload: commentData });
  } catch (error) {
    dispatch({ type: "FETCH_COMMENTS_DELIVERY_ERROR", payload: error });
  }
};

export const createDeliveryComment =
  (comment, delivery, user, successCallback, t) => async (dispatch) => {
    dispatch({ type: "CREATE_COMMENTS_DELIVERY_LOADING" });

    try {
      const {
        data: { data: commentData },
      } = await API.post(`${API_END_POINT}api/comments?populate=*`, {
        data: {
          text: comment?.text,
          delivery,
          user,
        },
      });

      if (comment?.attachments?.length > 0) {
        for (const file of comment?.attachments) {
          const fileId = await uploadFile(file);
          const { data } = await API.post(
            `${API_END_POINT}api/attachments?populate=*`,
            {
              data: {
                date: new Date(),
                file: fileId,
                comment: commentData?.id,
              },
            },
          );
          commentData.attributes.attachments.data?.push(data?.data);
        }
      }

      dispatch({
        type: "CREATE_COMMENTS_DELIVERY_SUCCESS",
        payload: {
          ...commentData,
          attributes: { ...commentData?.attributes },
        },
      });
      successCallback();
      toast.success(t("A comment has been added"));
    } catch (error) {
      console.log(error);
    }
  };

export const getDeliveryNumber = async (id) => {
  try {
    if (isDefined(id)) {
      const { data: DeliveryData } = await API.get(`api/deliveries/${id}`);
      if (DeliveryData?.attributes?.number) {
        return DeliveryData?.attributes?.number;
      }
    }
    const { data } = await API.get("api/deliveries", {
      params: {
        filters: {
          number: {
            $notNull: true,
          },
        },
        sort: ["number:desc"],
        pagination: {
          pageSize: 1,
        },
      },
    });
    const nextNumber = +(data?.data?.[0]?.attributes?.number || 0) + 1;
    return nextNumber;
  } catch (error) {
    return null;
  }
};
